module.exports = __webpack_public_path__ + "img/gig.e6d5189f.jpg";